<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
        <Modal v-model:visible="show_detail" backdrop>
            <template v-slot:header>
                <h2 class="text-2xl font-bold">Dettaglio</h2>
            </template>
            <template v-slot:main>
                <table>
                    <tr v-for="(v,k) in detail" :key="k">
                        <td class="w-1/2 font-bold border border-next-dark-gray">{{ k }}:</td>
                        <td class="w-1/2 border border-next-dark-gray">{{ v }}</td>
                    </tr>
                </table>
            </template>
            <template v-slot:footer>
                <div class="flex justify-between pt-3">
                    <NextButton variant="outline-secondary"
                                @click="show_detail =false"
                                class="py-2 px-4 w-full">
                        Chiudi
                    </NextButton>
                </div>
            </template>
        </Modal>
    </teleport>
    <div class="m-auto px-8 pb-8">
        <div class="m-auto pt-5">
            <div class="flex items-center justify-between">
                <h2 class="text-3xl font-bold mb-4">Fatture: {{ lista.rows[0]?.NODO || '---' }}</h2>
<!--                <NextButton :disabled="loading_download" variant="secondary" class="p-2" @click="export_data">Esporta</NextButton>-->
            </div>

            <div class="flex flex-col col-span-2 mb-2">
                <Field field_name="Cerca" @update:modelValue="lista.debounceSearch"
                       v-model="lista.search"
                       placeholder="Cerca"></Field>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 border-separate border-spacing-3 py-4 table-fixed"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        {{ $filters.toEuroCurrency(isNc ? c.TOT_PER_RIEPILOGO_NOTA_CREDITO : c.TOT_PER_RIEPILOGO_FATTURA || 0) }}
                    </template>
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_7`]="context">
                        <span @click="showData(c)"
                              class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></span>
                    </template>
                </NextTable>
            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import sottoProgettiManager from "@/api/SottoProgetti";
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import Paginator from "@/components/Paginator.vue";
import NextTable from "@/components/NextTable.vue";
import Lista from "@/setup/ListaCerca";
import InfiniteLoading from "v3-infinite-loading";

@Options({
    name: 'FattureClientiSottoProgetto',
    components: {NextTable, Paginator, Field, InfiniteLoading, Loading, Modal, NextButton},
    props: {
        id: [Number, String]
    },
    computed: {},
    methods: {}
})
export default class FattureClientiSottoProgetto extends Vue {
    lista: any = setup(() => Lista(sottoProgettiManager, this.cols, sottoProgettiManager.fattureClienti));
    id!: string;
    show_detail = false
    detail = null
    loading_download = false

    get isNc(){
        //@ts-ignore
        return Number(this.$route.query.nc)
    }

    created() {
        this.lista.callBinds = [this.id]
        //@ts-ignore
        this.lista.apiParams = this.$route.query
        this.lista.sort = 'NUMREG'
        this.lista.fetchData()
    }

    showData(data: any) {
        this.detail = data
        this.show_detail = true
    }

    export_data(){
        this.loading_download = true

    }

    cols = [
        {
            name: 'Numero reg.',
            prop: 'NUMREG',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Progressivo',
            prop: 'PROGRIGA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Attività',
            prop: 'DO41_SPESA_PD64',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Descrizione articolo',
            prop: 'DESCARTICOLO',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Quantità',
            prop: 'QTA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Prezzo',
            prop: 'TOT_PER_RIEPILOGO_FATTURA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Aliquota IVA',
            prop: 'ALIQIVA',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss" scoped>
.table-costi-ricavi {
    td {
        @apply p-2 text-sm relative bg-next-gray-md-dark
    }
}
</style>
